import { useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';
import { InteractiveInput } from 'Deer/components/Engagement/SurveyFormFilling/components/survey-form/InteractiveInput';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { MAX_OPTIONS_FOR_NPS } from '../constants/AddQuestionConstant';
import { useAddEngagementQuestion } from '../slice/AddEngagementQuestion.slice';

const QuestionPreview = () => {
  const { answerType, maxOptions, answerOptions, enableFeedbackText, isTextRequired } = useAddEngagementQuestion();

  const isNPS = useMemo(
    () => answerType === 'NUMBER_RATING' && maxOptions === MAX_OPTIONS_FOR_NPS,
    [answerType, maxOptions]
  );

  return (
    <Card style={{ marginTop: '16px' }}>
      <CardContent>
        <Box bg="#F5F7F9" p="8px" borderRadius="6px" mb="12px">
          <TextBodyMedium bold>PREVIEW</TextBodyMedium>
        </Box>
        <Box
          sx={{
            '& .interactive-input-engagement': {
              transform: isNPS ? 'scale(1)' : 'scale(0.8)',
              flexWrap: isNPS ? 'nowrap' : 'wrap',
            },
            '& .interactive-input-engagement > *': {
              minHeight: isNPS ? '40px !important' : '60px',
              minWidth: isNPS ? '40px !important' : '60px',
            },
            '& .interactive-input-engagement > * button': {
              height: isNPS ? '40px !important' : '60px',
              width: isNPS ? '40px !important' : '60px',
            },
          }}
        >
          <InteractiveInput data={answerOptions} type={answerType} onSelect={undefined} selectedId={null} />
          {enableFeedbackText && (
            <Box
              style={{
                margin: 'auto',
                overflowY: 'auto',
              }}
            >
              <AutoResizeInput
                isDashed
                placeholder={`Add a comment to this question${isTextRequired ? '*' : ''}`}
                rows={3}
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export { QuestionPreview };
